import Vue from "vue";

import RippleDirective from "vue-ripple-directive";
import AutoFocusDirective from "./directives/autoFocus";
import NumericDirective from "./directives/numeric";
import LengthDirective from "./directives/length";

Vue.directive("auto-focus", AutoFocusDirective);
Vue.directive("ripple", RippleDirective);
Vue.directive("numeric", NumericDirective);
Vue.directive("length", LengthDirective);
